"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var clsx_1 = __importDefault(require("clsx"));
var react_inlinesvg_1 = __importDefault(require("react-inlinesvg"));
var content_popout_svg_1 = __importDefault(require("@lifesize/ux-assets/vectors/svgIcons/content-popout.svg"));
var ux_assets_1 = require("@lifesize/ux-assets");
var core_1 = require("@material-ui/core");
var EventBus_1 = __importDefault(require("../../EventBus"));
var __1 = require("../..");
var constants_1 = require("./constants");
var useStyles = core_1.makeStyles(function () { return ({
    button: {
        alignItems: 'center',
        backgroundColor: core_1.fade(ux_assets_1.colors.black, 0.5),
        border: 'none',
        borderRadius: 25,
        boxSizing: 'border-box',
        color: ux_assets_1.colors.white,
        cursor: 'pointer',
        display: 'inline-flex',
        height: 50,
        minWidth: 50,
        opacity: 0,
        outline: 'none',
        padding: 0,
        transition: '0.2s ease-in-out',
        width: 'auto',
        '&.isVisible': {
            opacity: 1
        },
        '& .label': {
            flex: "1 1 auto",
            maxWidth: 0,
            overflow: 'hidden',
            transition: 'max-width 0.2s ease-in-out',
            '& span': {
                padding: "0 " + constants_1.space + "px 0 0",
                whiteSpace: 'nowrap',
            }
        },
        '&:hover': {
            '& .label': {
                maxWidth: 250
            }
        }
    },
    icon: {
        flex: '0 0 auto',
        height: 40,
        margin: 5,
        width: 'auto'
    }
}); });
var popoutPresentation = function () {
    return EventBus_1.default.Subject.next({ type: __1.constants.SET_PRESENTATION_LAYOUT_REQUEST, payload: __1.constants.SFU_PRES_LAYOUT_POPPEDOUT });
};
var PopoutButton = function (props) {
    var className = props.className, isVisible = props.isVisible;
    var classes = useStyles();
    var handleClick = react_1.useCallback(function () {
        popoutPresentation();
    }, [popoutPresentation]);
    return (react_1.default.createElement("button", { "data-testid": "popout-presentation", className: clsx_1.default(classes.button, className, isVisible && 'isVisible'), onClick: handleClick },
        react_1.default.createElement(react_inlinesvg_1.default, { src: content_popout_svg_1.default, className: classes.icon }),
        react_1.default.createElement("div", { className: "label" },
            react_1.default.createElement("span", null, props.intl['popoutLabel']))));
};
exports.default = PopoutButton;
